import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { ToastAnimation } from '../../animations/container-animation';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css',
  animations: [ToastAnimation.show],
  // preserveWhitespaces: false,
  standalone: true,
  imports: [MatIconModule, CommonModule],
})
export class ToastComponent extends Toast {
  undoString = 'undo';

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
    this.toastType = toastPackage.toastType;
  }

  toastType: string = 'toast-success';

  action(event: Event) {
    event.stopPropagation();
    this.undoString = 'undid';
    this.toastPackage.triggerAction();
    return false;
  }
}
